module.exports = __webpack_public_path__ + "static/img/13.b42146e3.png";